import { ADD_CONSTRUCTION_SITES, EDIT_CONSTRUCTION_SITES, REMOVE_CONSTRUCTION_SITES, LOAD_CONSTRUCTION_SITES } from '../actions/constructionSites';

const defaultState = [];

export default function(state=defaultState, action) {
  switch(action.type) {
    default:
      return state;
    case ADD_CONSTRUCTION_SITES:
      return [...state, action.data];
    case EDIT_CONSTRUCTION_SITES:
      return state.map(m => {
        if (m.id == action.data.id) {
          return {
            ...m,
            ...action.data
          };
        } else {
          return m;
        }
      });
    case REMOVE_CONSTRUCTION_SITES:
      return state.filter(({ id }) => id !== action.id);
    case LOAD_CONSTRUCTION_SITES:
      return action.data;
  }
}